import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Forbidden.css';

export default function Forbidden(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className="forbidden-page">
      <div className="forbidden-content">
        <h1 className="forbidden-code">403</h1>
        <h2 className="forbidden-title">Access Denied</h2>
        <p className="forbidden-message">
          You don't have permission to access this resource.
        </p>
        <button className="forbidden-home-button" onClick={() => navigate('/')}>
          Go to Home
        </button>
      </div>
    </div>
  );
}
